module.exports = __webpack_public_path__ + "static/media/SF-7-A (1).3f240aa8.mp3";